import React, {useEffect, useState} from "react";
import moment from 'moment';
import {Container, Grid} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";

const drawBuyUrl = (url) => {

    return (
        <Grid.Column width={3} color={'black'}>
            <div className={'middle'}>
                <a href={url} title={'Ver ao vivo'} target={'_black'} className={'white'}><FormattedMessage id="VER AO VIVO"/></a>
            </div>
        </Grid.Column>
    )
};

export const Countdown = ({eventStart, buyUrl}) => {

    const [now, setNow] = useState(moment().unix());
    const [start, setStart] = useState(now);
    const [duration, setDuration] = useState(false);

    useEffect(() => {

        setStart(moment(eventStart).unix());

    }, [eventStart]);

    useEffect(() => {

        let timerID = setInterval(() => tick(), 1000);

        return function cleanup() {
            clearInterval(timerID);
        };
    });

    useEffect(() => {
        const fetchData = async () => {

            let diff = (start - now) * 1000;

            if(diff <= 0){

                diff = 0;
            }

            setDuration(moment.duration(diff, 'milliseconds'));
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [now, start]);

    function tick() {
        setNow(moment().unix());
    }

    return (
        <Container as="section" fluid className="section-statistics">
            <Container>
                <Grid padded stretched textAlign={'center'} stackable>

                    <Grid.Column width={5}>
                        <div className={'middle'}>
                            <FormattedMessage id="TEMPO RESTANTE PARA O EVENTO"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <div>
                            <strong>{duration && duration.days()}</strong><br/><FormattedMessage id="DIAS"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <div>
                            <strong>{duration && duration.hours()}</strong><br/><FormattedMessage id="HORAS"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <div>
                            <strong>{duration && duration.minutes()}</strong><br/><FormattedMessage id="MINUTOS"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <div>
                            <strong>{duration && duration.seconds()}</strong><br/><FormattedMessage id="SEGUNDOS"/>
                        </div>
                    </Grid.Column>
                    {
                        buyUrl && drawBuyUrl(buyUrl)
                    }

                </Grid>
            </Container>
        </Container>
    );
};
